// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer__container-e68338 {
  width: 100%;
  max-width: calc(var(--max-width-article-layout) + 48px);
  box-sizing: border-box;
  align-self: center;
  padding: 0 24px;
}

.Footer__content-d63911 {
  height: 72px;
  border-top: 1px solid var(--base-30);
  display: flex;
  align-items: center;
}

.Footer__info-b66217 {
  margin-inline-start: auto;
  flex: 0;
  display: flex;
  align-items: center;
}

.Footer__views-aefe07 {
  flex: 0;
  margin-inline-start: 16px;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChannelPopups/ArticlePreview/Footer/styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,uDAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,yBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n  max-width: calc(var(--max-width-article-layout) + 24px * 2);\n  box-sizing: border-box;\n  align-self: center;\n  padding: 0 24px;\n}\n\n.content {\n  height: 72px;\n  border-top: 1px solid var(--base-30);\n  display: flex;\n  align-items: center;\n}\n\n.info {\n  margin-inline-start: auto;\n  flex: 0;\n  display: flex;\n  align-items: center;\n}\n\n.views {\n  flex: 0;\n  margin-inline-start: 16px;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Footer__container-e68338`,
	"content": `Footer__content-d63911`,
	"info": `Footer__info-b66217`,
	"views": `Footer__views-aefe07`
};
module.exports = ___CSS_LOADER_EXPORT___;
